module.exports = "/_next/static/images/a22072229c1147a22f69a77b57e66a8b-hero-xs.jpg.webp";